import React, { type CSSProperties } from 'react';
import cn from 'classnames';

import EmptyBlock from 'src/routes/Hotel/components/EmptyBlock';
import { FORTUNA_ASSETS } from 'src/constants/fortunaAssets';
import { useTranslation } from '@lt/localization';

import type { RouletteMapProps as Props } from './types';

import styles from './rouletteMap.module.css';

const RouletteMap = ({ className = '', isMobile = false, location }: Props) => {
  const { t } = useTranslation();

  return (
    <EmptyBlock
      className={className}
      isMobile={isMobile}
      image={
        <div
          style={
            {
              '--background-url-1x-ratio': `url(${FORTUNA_ASSETS['hotels/fortuna-mobile.jpg']})`,
              '--background-url-2x-ratio': `url(${FORTUNA_ASSETS['hotels/fortuna-mobile@2x.jpg']})`,
              '--background-url-3x-ratio': `url(${FORTUNA_ASSETS['hotels/fortuna-mobile@3x.jpg']})`,
            } as CSSProperties
          }
          className={cn(styles.rouletteImage, {
            [styles.mobileRouletteImage]: isMobile,
          })}
        />
      }
      title={t('map.roulette.title', { location })}
    />
  );
};

export default RouletteMap;
